import React from 'react';

import classNames from 'classnames';

import { i18n } from '../../i18n';

import './NonEditableText.scss';

interface EmojiWrappedTextProps {
    content: string;
}

// Finding the simplest solution to capturing ALL emojis
// while still supporting the browser range we are building for
// has proven difficult. It might be that we need to return to
// `/(\p{Emoji}+)/gu` but specifically filter out digits,
// which were previously being captured.
const EMOJI_REGEXP = /(\p{Extended_Pictographic}+)/gu;

// TODO: Emojis are represented by several characters,
// therefor calling `.length` on a string containing emojis
// can return a value that does not align with what we visually perceive.
// We may need to use grapheme-splitter if we care about this.
function EmojiWrappedText({ content }: EmojiWrappedTextProps) {
    function wrapEmoji(text: string, index: number) {
        return text.match(EMOJI_REGEXP) ? (
            <span key={`EmojiWrappedText-${index}`} className="NonEditableText-Content-Emoji">
                {text}
            </span>
        ) : (
            text
        );
    }

    return <>{content.split(EMOJI_REGEXP).map(wrapEmoji)}</>;
}

export interface NonEditableTextProps {
    content: string;
    heading?: boolean;
    onAction?: () => void;
}

export function NonEditableText({ content, heading = false, onAction }: NonEditableTextProps) {
    const contentClassNames = classNames('NonEditableText-Content', {
        'NonEditableText-Content--heading': heading,
        'NonEditableText-Content--paragraph': !heading,
    });

    const contentMarkup = (
        <span className={contentClassNames}>
            <EmojiWrappedText content={content} />
        </span>
    );

    return onAction ? (
        <button type="button" className="NonEditableText" aria-label={i18n.nonEditableTitle} onClick={onAction}>
            {contentMarkup}
        </button>
    ) : (
        contentMarkup
    );
}
